// src/components/home/GeoButton.js
// Bouton de recherche par proximité - NE PAS MODIFIER

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGeolocation } from '../../hooks/useGeolocation';
import { useTheme } from '../../hooks/useTheme';
import ROUTES from '../../constants/routes';

const GeoButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { theme } = useTheme();
  const { location, error, loading, requestLocation } = useGeolocation();

  const handleClick = () => {
    if (location) {
      navigate(`${ROUTES.SEARCH}?lat=${location.lat}&lng=${location.lng}`);
    } else {
      requestLocation();
    }
  };

  React.useEffect(() => {
    if (location) {
      navigate(`${ROUTES.SEARCH}?lat=${location.lat}&lng=${location.lng}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const styles = {
    container: {
      padding: '0 16px',
      marginBottom: '16px',
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      width: '100%',
      padding: '14px 16px',
      backgroundColor: theme.bgCard,
      border: `1px solid ${theme.border}`,
      borderRadius: '12px',
      cursor: 'pointer',
      transition: 'all 200ms ease-in-out',
      minHeight: '52px',
      textAlign: 'left',
    },
    iconCircle: {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      backgroundColor: theme.goldSoft,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '15px',
      flexShrink: 0,
    },
    textGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1px',
    },
    label: {
      fontSize: '14px',
      fontWeight: '700',
      color: theme.textPrimary,
    },
    subLabel: {
      fontSize: '12px',
      color: theme.textSecondary,
    },
    arrow: {
      marginLeft: 'auto',
      color: theme.gold,
      fontSize: '16px',
    },
    error: {
      fontSize: '12px',
      color: '#F56565',
      marginTop: '8px',
      textAlign: 'center',
    },
  };

  return (
    <div style={styles.container}>
      <button
        style={styles.button}
        onClick={handleClick}
        disabled={loading}
        onMouseEnter={(e) => (e.currentTarget.style.borderColor = theme.goldBorder)}
        onMouseLeave={(e) => (e.currentTarget.style.borderColor = theme.border)}
      >
        <div style={styles.iconCircle}>{loading ? '⏳' : '🧭'}</div>
        <div style={styles.textGroup}>
          <span style={styles.label}>{loading ? t('common.loading') : t('home.useLocation')}</span>
          <span style={styles.subLabel}>Hôtels, meublés, terrains… autour de vous</span>
        </div>
        <span style={styles.arrow}>→</span>
      </button>
      {error && <div style={styles.error}>{error}</div>}
    </div>
  );
};

export default GeoButton;